<div class="progress-cont">
    <div class="progress bg-primary" [style.width]="progress + '%'">
    </div>
  </div>

